import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import { webDataDrawerElements } from "data/radhamaniPageData";
import { useNavigate, useOutletContext } from "react-router-dom";
import { ArrowBackRounded, KeyboardBackspaceRounded } from "@mui/icons-material";
import { replenishmentDrawerElements } from "./data";
import { IconButton, Typography, Alert } from "@mui/material";
import { AuthState } from "context/AuthContext";
import { admin } from "data/authData";
import LogicProfiles from "./Replenishment/LogicProfiles/LogicProfiles";
import ExecuteLogics from "./Replenishment/ExecuteLogics/ExecuteLogics";
import FileUpload from "./Replenishment/FileUpload/FileUpload";
import SelectedLogicProfile from "./Replenishment/SelectedLogicProfile/SelectedLogicProfile";
import ReplJobs from "./Replenishment/ReplJobs/ReplJobs";
import SelectedJob from "./Replenishment/SelectedJob/SelectedJob";
import WHAllocation from "components/WHAllocation/WHAllocation";
import History from "components/WHAllocation/History";
import { rootProtectedPath } from "data/authData";
import { useState, useEffect } from "react";

const axisMainPath = `/${rootProtectedPath}/replenishment/${replenishmentDrawerElements.axis.key}/${replenishmentDrawerElements.axis.types.axis_main.key}`;
const axisHistoryKey = replenishmentDrawerElements.axis.types.axis_history.key;

const axisTabKeys = [replenishmentDrawerElements.axis.types.axis_main.key, replenishmentDrawerElements.axis.types.axis_history.key];

const ReplenishmentDashboard = () => {
	const [pathName, service] = useOutletContext();
	const navigate = useNavigate();
	const { user } = AuthState();
	const [historyRefreshKey, setHistoryRefreshKey] = useState(0);

	const hasAxisAccess = () => user?.role?.[admin] || user?.role?.AXIS;
	const isAxisTab = pathName && axisTabKeys.includes(pathName);
	const showAxisAccessDenied = isAxisTab && !hasAxisAccess();

	// Increment refresh key each time the user navigates to the History tab
	useEffect(() => {
		if (pathName === axisHistoryKey) {
			setHistoryRefreshKey((k) => k + 1);
		}
	}, [pathName]);

	const handleResumeFromHistory = (job) => {
		navigate(axisMainPath, { state: { resumeJob: job } });
	};

	const tabComponents = {
		[replenishmentDrawerElements.replenishment.types.repl_logics.key]: {
			...replenishmentDrawerElements.replenishment.types.repl_logics,
			component: <LogicProfiles activeService={service} />,
		},
		[replenishmentDrawerElements.replenishment.types.execute_logics.key]: {
			...replenishmentDrawerElements.replenishment.types.execute_logics,
			component: <ExecuteLogics activeService={service} />,
		},
		[replenishmentDrawerElements.replenishment.types.repl_upload_files.key]: {
			...replenishmentDrawerElements.replenishment.types.repl_upload_files,
			component: <FileUpload activeService={service} />,
		},
		[replenishmentDrawerElements.replenishment.types.repl_selected_logic.key]: {
			...replenishmentDrawerElements.replenishment.types.repl_selected_logic,
			component: <SelectedLogicProfile activeService={service} />,
		},
		[replenishmentDrawerElements.replenishment.types.repl_selected_job.key]: {
			...replenishmentDrawerElements.replenishment.types.repl_selected_job,
			component: <SelectedJob activeService={service} />,
		},
		[replenishmentDrawerElements.axis.types.axis_main.key]: {
			...replenishmentDrawerElements.axis.types.axis_main,
			component: <WHAllocation />,
		},
		[replenishmentDrawerElements.axis.types.axis_history.key]: {
			...replenishmentDrawerElements.axis.types.axis_history,
			component: <History onResumeJob={handleResumeFromHistory} refreshKey={historyRefreshKey} />,
		},
		// [replenishmentDrawerElements.replenishment.types.repl_jobs.key]: {
		// 	...replenishmentDrawerElements.replenishment.types.repl_jobs,
		// 	component: <ReplJobs />,
		// },
	};
	return (
		<Box sx={{ width: "100%" }}>
			<Box display="flex" alignItems="center" columnGap={1}>
				<IconButton onClick={() => navigate(-1)}>
					<ArrowBackRounded />
				</IconButton>
				<Typography variant="h5">{service?.name}</Typography>
			</Box>
			<Box width="95%" margin="auto">
				{showAxisAccessDenied ? (
					<Alert severity="error" sx={{ mt: 2 }}>
						<Typography variant="subtitle1" gutterBottom>
							Access denied
						</Typography>
						<Typography variant="body2" color="text.secondary">
							You do not have access to AXIS. Contact your administrator to get AXIS access (role.AXIS at service level).
						</Typography>
						<Button
							variant="outlined"
							size="small"
							sx={{ mt: 2 }}
							onClick={() =>
								navigate(`/${rootProtectedPath}/replenishment/${replenishmentDrawerElements.replenishment.key}/${replenishmentDrawerElements.replenishment.types.repl_logics.key}`)
							}>
							Back to Replenishment
						</Button>
					</Alert>
				) : (
					tabComponents?.[pathName]?.component
				)}
			</Box>

			{/* {tabComponents&&
				tabComponents.map((row) => (
					<Box width="95%" margin="auto" key={row.key} display={row.key === pathName ? "block" : "none"}>
						{row.component}
					</Box>
				))} */}
		</Box>
	);
};

export default ReplenishmentDashboard;
